export const MAP_ID = "cdp-map";
export const MAP_STYLES = {
    STANDARD: "standard",
    SATELLITE: "standard-satellite",
    THREE_DIMENSIONAL: "three-dimensional",
};
export const SIDEBAR_WIDTH = 480;
export const DEFAULT_ZOOM = 14;
export const DEFAULT_BEARING = 0;
export const DEFAULT_PITCH = 0;
export const THREE_D_PITCH = 60;
export const THREE_D_ZOOM = 17;
export const DEFAULT_STYLE = MAP_STYLES.STANDARD;
export const DEFAULT_CENTER = [2.333333, 48.866667]; // Paris
export const MIN_ZOOM = 9;
export const MAX_ZOOM = 14;
export const TRANSPORTATION_MODES = ["car", "transit", "walk", "bike"];
export const DEFAULT_LAYER_TYPE = "TRANSPORT";
export const TRANSPORT_CONFIGS = {
    subway: {
        layerKey: "pofi_subway_line",
        label: "subway",
        tileType: "SUBWAY.LINE",
    },
    train: {
        layerKey: "pofi_train_line",
        label: "train",
        tileType: "TRAIN.INTERCITY_LINE",
    },
    tram: {
        layerKey: "pofi_tram_line",
        label: "tram",
        tileType: "TRAM.LINE",
    },
};
export const TRANSPORT_TYPES = Object.values(TRANSPORT_CONFIGS);
export const TRANSPORT_LAYER_KEYS = Object.values(TRANSPORT_CONFIGS).map((config) => config.layerKey);
